<template>
  <div class="mx-auto py-4">
    <div
        style="display: flex; justify-content: right; padding-right: 2%; background-color: #efefef !important;"
    >
      <v-switch
          v-model="summary"
          :label="
          `Report Type: ${summary == true ? 'Cpd Provider' : 'Accreditor'}`
        "
          class="black--text"
      ></v-switch>
    </div>
    <v-card v-if="summary == true" class="mx-4 my-2">
      <v-card-title>
        Newly Registered Cpd Provider Report
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel
 v-if="$can('renewal-report', 'export')"              :data="summarySelected"
              :fields="summary_export_fields"
              name="newlyRegisteredCpdProvidorReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          v-model="summarySelected"
          :headers="summaryHeaders"
          :items="cpdProviderReport.rows"
          :loading="summaryLoading"
          :options.sync="options"
          :server-items-length="cpdProviderReport.count"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-menu ref="menu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="startDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    ref="startDateValue"
                    v-model="startDateValue"
                    no-title
                    placeholder="Start Date"
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-menu ref="menu" v-model="startMenu2" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="endDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    ref="endDateValue"
                    v-model="endDateValue"
                    no-title
                    placeholder="End Date"
                    scrollable
                    @input="startMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout
          >
        </template>
      </v-data-table>
    </v-card>
    <v-card v-else class="mx-4 my-3">
      <v-card-title>
        Newly Registered Accreditor Report
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel
 v-if="$can('renewal-report', 'export')"              :data="detailSelected"
              :fields="export_fields"
              name="NewlyRegisteredAccreditorReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          v-model="detailSelected"
          :headers="headers"
          :items="accreditorReport.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="accreditorReport.count"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-menu ref="menu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="startDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    ref="startDateValue" v-model="startDateValue" no-title
                    placeholder="Start Date" scrollable @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-menu ref="menu" v-model="startMenu2" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="endDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    ref="endDateValue" v-model="endDateValue" no-title
                    placeholder="End Date" scrollable @input="startMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {RenewalStatusReportService} from "../renewal-status-report-service";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      summary_export_fields: {
        "Cpd Provider Name": "trainingCenterName",
        "Created Date": "createdAt",
        "cpdProviderOwnership": "cpdProviderOwnership",
        "institutionPhoneNumber": "institutionPhoneNumber",
      },
      summaryHeaders: [
        {
          text: "Cpd Provider Name",
          value: "trainingCenterName",
        },
        {
          text: "Created Date",
          value: "createdAt",
        },
        {
          text: "cpdProviderOwnership",
          value: "cpdProviderOwnership",
        },
        {
          text: "institutionPhoneNumber",
          value: "institutionPhoneNumber",
        },

      ],
      summaryLoading: false,
      cpdProviderReport: [],
      summarySelected: [],
      summary: true,
      accreditorReport: [],
      loading: false,
      selected: [],
      export_fields: {
        "Accreditor Name": "accreditorName",
        "Created Date": "createdAt",
        "Accreditor Ownership": "accreditorOwnership",
        "Accreditation Date": "accreditationDate",
      },
      headers: [
        {text: "Accreditor Name", value: "accreditorName"},
        {text: "Created Date", value: "createdAt"},
        {text: "Accreditor Ownership", value: "accreditorOwnership"},
        {text: "Accreditation Date", value: "accreditationDate"}
      ],
      detailSelected: [],
      isWithdrawnValue: "Both",
      startDateValue: null,
      endDateValue: null,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,
      startMenu: false,
      startMenu2: false,
      clearable: null,
    };
  },
  async beforeMount() {
    this.fetchCpdProviderReports();
    this.fetchAccreditorReports();
  },
  watch: {
    options: {
      handler() {
        this.fetchCpdProviderReports();
        this.fetchAccreditorReports();
      },
      deep: true,
    },
    startDateValue: function (val) {
      this.startDateValue = val == '' ? null : val;
      this.fetchCpdProviderReports();
      this.fetchAccreditorReports();
    },
    endDateValue: function (val) {
      this.endDateValue = val == '' ? null : val;
      this.fetchCpdProviderReports();
      this.fetchAccreditorReports();
    },
    dateRangePreset: function (val) {
      this.applyPresetWithSelection(val, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod: function () {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  methods: {
    async fetchCpdProviderReports() {
      this.summaryLoading = true;

      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}&`);

      this.startDateValue !== null && (searchParams += '&startDate=' + this.startDateValue);
      this.endDateValue !== null && (searchParams += '&endDate=' + this.endDateValue);

      const res = await RenewalStatusReportService.getNewlyCpdProviders(searchParams);
      if (res.status === 200) {
        this.summaryLoading = false;
        this.cpdProviderReport = res.data;
      } else {
        this.summaryLoading = false;
        this.$toast.error(
            "There was a problem fetching newly cpd provider reports, Please try Again!"
        );
      }
    },
    async fetchAccreditorReports() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.startDateValue !== null && (searchParams += '&startDate=' + this.startDateValue);
      this.endDateValue !== null && (searchParams += '&endDate=' + this.endDateValue);
      const res = await RenewalStatusReportService.getNewlyAccreditors(searchParams);

      if (res.status === 200) {
        this.loading = false;
        this.accreditorReport = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching newly registered accreditors reports, Please try Again!"
        );
      }
    },
  },
};
</script>

<style>
.theme--light.v-label {
  color: rgba(0, 0, 0, 0.7);
}

.comparisonSelect {
  font-weight: bold;
  font-size: medium;
}
</style>
